import { create } from 'zustand';
import type { OrganizationBusinessProfile } from '../domain/businessProfile';

type BusinessProfileState = {
  profile: OrganizationBusinessProfile | null;
  setProfile: (profile: OrganizationBusinessProfile | null) => void;
  resetProfile: () => void;
};

export const useBusinessProfileStore = create<BusinessProfileState>((set) => ({
  profile: null,
  setProfile: (profile) => set({ profile }),
  resetProfile: () => set({ profile: null }),
}));
